import { withTranslation } from 'react-i18next';
import CompletedTasksTable from './CompletedTasksTable';

export default withTranslation('pages')(CompletedTasksTable);
